'use client';

import type { URLCardProps } from 'mdx-transformer';

/**
 * Render an Apple Notes like URL card
 */
export function URLCard({ url, og, title, favicon }: URLCardProps) {
  const domain = new URL(url).hostname;
  const faviconUrl =
    favicon || `https://www.google.com/s2/favicons?domain=${domain}&sz=128`;
  return (
    <section
      className="not-prose my-5 flex max-w-[600px] cursor-pointer flex-col rounded-xl border bg-quaternary"
      onClick={() => {
        window.open(url, '_blank', 'nofollow,noopener,noreferrer');
      }}
    >
      {og?.startsWith('https://') && (
        <img
          src={og}
          alt="Cover"
          className="rounded-t-lg bg-primary"
          data-zoom="false"
        />
      )}
      <div className="flex items-center justify-between gap-2.5 p-3">
        <div>
          <h5 className="m-0 text-md font-semibold text-primary">{title}</h5>
          <p className="m-0 text-sm text-quaternary">{domain}</p>
        </div>
        {faviconUrl?.startsWith('https://') && (
          <img
            src={faviconUrl}
            className="size-12"
            alt={domain}
            data-zoom="false"
          />
        )}
      </div>
    </section>
  );
}
